import { render, staticRenderFns } from "./FormCheckbox.vue?vue&type=template&id=5a8bfbb0"
import script from "./FormCheckbox.vue?vue&type=script&lang=js"
export * from "./FormCheckbox.vue?vue&type=script&lang=js"
import style0 from "./FormCheckbox.vue?vue&type=style&index=0&id=5a8bfbb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports